<template>
    <sign-up-form
        id="book-insighs-sign-up"
        ref="signUpForm"
        form-class="primary"
        @submit-data="$_verifyAccountEmail"
    >
        <template v-slot:before-submit-btn>
            <div class="form-check">
                <input
                    id="newsletter-validation"
                    v-model="includeUserInNewsletter"
                    name="newsletter-validation"
                    class="form-check-input"
                    type="checkbox"
                >
                <label class="form-check-label" for="newsletter-validation">
                    Get a new Book Insight delivered straight to your inbox every week
                </label>
            </div>
        </template>
        <template v-slot:submit-btn-text>
            Create Free Account
        </template>
        <template v-slot:after-email-input>
            <slot name="sign-in-link">
                <p class="log-in-link">
                    Already have an account?
                    <router-link
                        class="text-primary"
                        replace
                        :to="{ name: 'bi-sign-in', query: {...$route.query}, params:{...$route.params} }"
                    >
                        Sign in
                    </router-link>
                </p>
            </slot>
            <div class="or">
                <p>Or</p>
            </div>
            <facebook-auth icon-color="white" @facebook-login="$_handleFacebookAuth">
                <template v-slot:default>
                    Connect With Facebook
                </template>
            </facebook-auth>
            <div class="terms-conditions text-center">
                By continuing, you agree to the hibooks
                <router-link
                    class="text-primary"
                    :class="{ 'active' : $route.params.section == 'terms-and-conditions' }"
                    :to="{ name: 'book-insight-legal-term-of-service' }"
                    tabindex="-1"
                >
                    Terms
                </router-link> and
                <router-link
                    class="text-primary"
                    :class="{ 'active' : $route.params.section == 'terms-and-conditions' }"
                    :to="{ name: 'book-insight-legal-privacy-policy' }"
                    tabindex="-1"
                >
                    Privacy Policy.
                </router-link>
            </div>
        </template>
    </sign-up-form>
</template>

<script>
import SignUp from "@/mixins/signUp.js";
import _isEmpty from "lodash/isEmpty";
import { getCurrentDateTime } from "@/utils/helpers";

export default {
    name: "InsightsLandingSignUpForm",
    components: {
        SignUpForm: () => import(/* webpackChunkName: "sing-up-form"*/ "@c/auth/sign-up/form")
    },
    mixins: [SignUp],
    props: {
        trackingProperties: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            includeUserInNewsletter: true
        }
    },
    methods: {
        $_handleSuccessfullAuth(user = {}, method = "email") {
            // TODO Show the user a success notification
            this.$emit("auth-sucessfull", user, this.includeUserInNewsletter);
            this.$store.dispatch("User/setToken", user.token);
            Cookies.set("token", user.token);

            this.$_signUpTrackings(user, this.trackingProperties, method);
            const defaultRouteToGo = { name: "subscription-book-insights" };
            if (this.useRouteHandler) {
                this.$_handleNextRoute(this.$route, defaultRouteToGo);
            }
        },
        $_signUpTrackings(userData = {}, props = {}, method = "email") {
            const user = userData.user;
            const isEmailLogin = _isEmpty(user.facebook);
            const email = isEmailLogin ? user.email : user.facebook.email_address;
            // Leanplum first user configuration
            Leanplum.setUserId(user.id);
            const userAttributes = {
                email,
                "backend_id": user.id,
                "first_name": user.first_name
            };
            const firstTrackingEvent = {
                method,
                "account_creation_date": getCurrentDateTime(),
                ...props
            }
            Leanplum.setUserAttributes(userAttributes);
            Leanplum.track("web_account_created", firstTrackingEvent);

            if (!_isEmpty(analytics)) {
                analytics.identify(user.id);
                analytics.track("web_account_created", firstTrackingEvent);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.form-check {
    font-size: 15px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.4px;
}
</style>
